/**
 * Azure resource template deployment api body.
 */
export interface DeploymentOperationRequestBody {
    /**
     * The deployment properties.
     */
    properties: DeploymentProperties;
}

/**
 * Azure resource template deployment properties
 */
export interface DeploymentProperties {
    /**
     * The resource template.
     */
    template: string;

    /**
     * The template parameters.
     */
    parameters: string;

    /**
     * The deployment mode.
     */
    mode: string;
}
